module.exports = __webpack_public_path__ + "img/goods14_2.c5a46f89.jpg";